import { Link } from "react-router-dom";
import { mediaIdOf } from "@/shared/lib/format";
import { proxyImageUrl } from "@/shared/lib/image";

export interface MediaCardItem {
  title?: string | null;
  year?: string | null;
  type?: string | null;
  poster_path?: string | null;
  vote_average?: number | null;
  tmdb_id?: number | null;
  douban_id?: string | null;
  bangumi_id?: number | null;
  tmdbid?: number | null;
  doubanid?: string | null;
  bangumiid?: number | null;
}

/** 海报卡片：点进详情 */
export function MediaCard({ item }: { item: MediaCardItem }) {
  const id = mediaIdOf({
    tmdb_id: item.tmdb_id ?? item.tmdbid,
    douban_id: item.douban_id ?? item.doubanid,
    bangumi_id: item.bangumi_id ?? item.bangumiid,
  });
  const type = item.type || "电影";
  const poster = proxyImageUrl(item.poster_path);
  const body = (
    <>
      <div className="aspect-[2/3] overflow-hidden bg-bg-hover">
        {poster ? (
          <img
            src={poster}
            alt=""
            className="h-full w-full object-cover transition-transform duration-[var(--dur)] group-hover:scale-[1.03]"
            loading="lazy"
            referrerPolicy="no-referrer"
          />
        ) : (
          <div className="flex h-full items-center justify-center text-[11px] text-fg-subtle">
            无海报
          </div>
        )}
      </div>
      <div className="p-2">
        <div className="truncate text-[13px] font-medium text-fg">
          {item.title || "未知"}
        </div>
        <div className="mt-0.5 truncate text-[11px] text-fg-subtle">
          {[item.year, type, item.vote_average ? `★ ${item.vote_average}` : null]
            .filter(Boolean)
            .join(" · ")}
        </div>
      </div>
    </>
  );

  const className =
    "group block overflow-hidden rounded-[var(--radius-md)] border border-border bg-bg-card transition-colors hover:border-border-strong";

  if (!id) {
    return <div className={className}>{body}</div>;
  }

  return (
    <Link
      to={`/media/${encodeURIComponent(id)}?type=${encodeURIComponent(type)}`}
      className={className}
    >
      {body}
    </Link>
  );
}

/** 海报墙骨架 */
export function MediaCardSkeleton({ count = 12 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-6">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="overflow-hidden rounded-[var(--radius-md)] border border-border bg-bg-card"
        >
          <div className="aspect-[2/3] animate-pulse bg-bg-hover" />
          <div className="space-y-2 p-2">
            <div className="h-3 w-3/4 animate-pulse rounded bg-bg-hover" />
            <div className="h-2.5 w-1/2 animate-pulse rounded bg-bg-hover" />
          </div>
        </div>
      ))}
    </div>
  );
}
